import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import InstallPrompt from './InstallPrompt'
import { useEffect, useState } from 'react'
import { db } from '../utils/photos-db'
import './App.css'
import Login from './Login'
import Home from './Home'

function AppContent() {
  const [isDbReady, setIsDbReady] = useState(false);

  useEffect(() => {
    const initDb = async () => {
      await db;
      setIsDbReady(true);
    };
    initDb();
  }, []);

  if (!isDbReady) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Home />} />
        </Routes>
      </Router>
      <InstallPrompt />
    </>
  );
}

function App() {
  return <AppContent />;
}

export default App;